<template>
    <ConfirmationDialog
        :isOpen="isOpen"
        :title="$t('stock.leave.title')"
        :message="message"
        :confirmText="$t('stock.leave.discard')"
        :cancelText="$t('stock.leave.continue')"
        type="warning"
        @confirm="$emit('discard')"
        @cancel="$emit('continue')"
    />
</template>

<script>
import ConfirmationDialog from '../../Shared/ConfirmationDialog.vue'

export default {
    name: 'StockLeaveDialog',
    components: { ConfirmationDialog },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        count: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        message() {
            const key = this.count > 1 ? 'stock.leave.message_other' : 'stock.leave.message_one'
            return this.$t(key, { count: this.count })
        },
    },
}
</script>
